import { useState } from 'react'
import { BANKS, getPreferredBank, setPreferredBank } from '@core/banks'
import { Card } from '@design/components'

/**
 * Which bank app you actually use.
 *
 * It changes what the payment screen says above the QR code — the wording of
 * "scan dit in je bankapp" is different enough per bank that a generic
 * sentence makes people hesitate at exactly the wrong moment. The setting has
 * existed in code since the payment card was built and has never had a way to
 * change it.
 */
export function BankSetting() {
  const [current, setCurrent] = useState(getPreferredBank().id)

  return (
    <Card className="mb-4">
      <p className="font-medium mb-1">Je bank</p>
      <p className="text-sm text-muted mb-3">
        Bepaalt hoe het betaalscherm de QR-code uitlegt.
      </p>
      <div className="flex flex-wrap gap-2">
        {BANKS.map((bank) => (
          <button
            key={bank.id}
            onClick={() => {
              setPreferredBank(bank.id)
              setCurrent(bank.id)
            }}
            className={`min-h-[2.75rem] px-4 rounded-xl border text-sm font-medium ${
              bank.id === current ? 'border-ink bg-ink/5' : 'border-line text-muted'
            }`}
          >
            {bank.name}
          </button>
        ))}
      </div>
    </Card>
  )
}
